/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminTeamMatchResponse,
  GetAdminTeamsMatchingDataParams,
  HTTPValidationError,
  TeamMatchDetailsResponse,
} from './platformapi.schemas';

import getAdminTeamsMatchingDataMutator from '../custom-axios-instance';
import getAdminTeamMatchDetailsMutator from '../custom-axios-instance';

/**
 * Get matching data for teams based on the provided filters and pagination.
 * @summary Get Admin Teams Matching Data
 */
export const getAdminTeamsMatchingData = (
  params?: GetAdminTeamsMatchingDataParams,
  signal?: AbortSignal,
) => {
  return getAdminTeamsMatchingDataMutator<AdminTeamMatchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/match-teams/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminTeamsMatchingDataQueryKey = (params?: GetAdminTeamsMatchingDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/match-teams/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminTeamsMatchingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminTeamsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamsMatchingData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminTeamsMatchingDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTeamsMatchingData>>> = ({
    signal,
  }) => getAdminTeamsMatchingData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTeamsMatchingDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTeamsMatchingData>>
>;
export type GetAdminTeamsMatchingDataQueryError = void | HTTPValidationError;

export function useGetAdminTeamsMatchingData<
  TData = Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminTeamsMatchingDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamsMatchingData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
          TError,
          Awaited<ReturnType<typeof getAdminTeamsMatchingData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminTeamsMatchingData<
  TData = Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminTeamsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamsMatchingData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
          TError,
          Awaited<ReturnType<typeof getAdminTeamsMatchingData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminTeamsMatchingData<
  TData = Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminTeamsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamsMatchingData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Teams Matching Data
 */

export function useGetAdminTeamsMatchingData<
  TData = Awaited<ReturnType<typeof getAdminTeamsMatchingData>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminTeamsMatchingDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamsMatchingData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminTeamsMatchingDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed information for a specific team match by discovery ID.
 * @summary Get Admin Team Match Details
 */
export const getAdminTeamMatchDetails = (discoveryId: number, signal?: AbortSignal) => {
  return getAdminTeamMatchDetailsMutator<TeamMatchDetailsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/match-teams/${discoveryId}`,
    method: 'GET',
    signal,
  });
};

export const getGetAdminTeamMatchDetailsQueryKey = (discoveryId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/match-teams/${discoveryId}`] as const;
};

export const getGetAdminTeamMatchDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
  TError = void | HTTPValidationError,
>(
  discoveryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamMatchDetails>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminTeamMatchDetailsQueryKey(discoveryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTeamMatchDetails>>> = ({
    signal,
  }) => getAdminTeamMatchDetails(discoveryId, signal);

  return { queryKey, queryFn, enabled: !!discoveryId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTeamMatchDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTeamMatchDetails>>
>;
export type GetAdminTeamMatchDetailsQueryError = void | HTTPValidationError;

export function useGetAdminTeamMatchDetails<
  TData = Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
  TError = void | HTTPValidationError,
>(
  discoveryId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamMatchDetails>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
          TError,
          Awaited<ReturnType<typeof getAdminTeamMatchDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminTeamMatchDetails<
  TData = Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
  TError = void | HTTPValidationError,
>(
  discoveryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamMatchDetails>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
          TError,
          Awaited<ReturnType<typeof getAdminTeamMatchDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAdminTeamMatchDetails<
  TData = Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
  TError = void | HTTPValidationError,
>(
  discoveryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamMatchDetails>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Admin Team Match Details
 */

export function useGetAdminTeamMatchDetails<
  TData = Awaited<ReturnType<typeof getAdminTeamMatchDetails>>,
  TError = void | HTTPValidationError,
>(
  discoveryId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminTeamMatchDetails>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminTeamMatchDetailsQueryOptions(discoveryId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
